import React, { useContext, useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import Context from "../OriginStoryProvider";
import FullWidthImage from "../Shared/FullWidthImage";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const ImageWithArrows = () => {
	const {
		data: { content },
	} = useContext(Context);

	const container = useRef(null);

	useGSAP(
		() => {
			let mm = gsap.matchMedia();
			mm.add(
				{
					isMediumScreen: "(min-width: 768px)",
					isMobile: "(max-width: 767px)",
				},
				(context) => {
					const { isMediumScreen, isMobile } = context.conditions;
					if (isMobile) {
						gsap.set(".arrow", { opacity: 1 });
						gsap.to(".arrow", {
							duration: 0.85,
							yPercent: 10,
							ease: "power1.inOut",
							repeat: -1,
							yoyo: true,
							stagger: 0.25,
						});
					}
					if (isMediumScreen) {
						gsap.set(".arrow", { opacity: 0 });
						let arrows = gsap.utils.toArray(".arrow");

						const tl = gsap.timeline();

						arrows.forEach((arrow) => {
							tl.to(arrow, {
								opacity: 1,
								duration: 0.25,
								ease: "power1.in",
							});

							tl.to(arrow, {
								duration: 0.85,
								yPercent: 10,
								ease: "power1.inOut",
								repeat: -1,
								yoyo: true,
							});
						});

						tl.play();
						return ScrollTrigger.create({
							trigger: ".chapter-2__image-arrows",
							start: "top top",
							scrub: false,
							animation: tl,
							pinSpacing: true,
							pin: true,
						});
					}
				}
			);
		},
		{ scope: container.current, dependencies: [content.chapters] }
	);

	return (
		<div className="chapter-2__image-arrows" ref={container}>
			<div className="chapter-2__image-arrows__wrap">
				<div className="chapter-2__image-arrows__wrap__grid">
					<div className="arrow arrow--1">
						<img
							src={`${mainScript.assetPath}images/svg/icons/icon-arrow-red-down.svg`}
							alt="Arrow"
							loading="lazy"
						/>
						<p className="arrow__text">
							{content.chapters.second.image_with_arrows.arrow_1}
						</p>
					</div>
					<div className="arrow arrow--2">
						<img
							src={`${mainScript.assetPath}images/svg/icons/icon-arrow-red-down.svg`}
							alt="Arrow"
							loading="lazy"
						/>
						<p className="arrow__text">
							{content.chapters.second.image_with_arrows.arrow_2}
						</p>
					</div>
				</div>
				<FullWidthImage
					imgSizes="(max-width: 420px) 420px, (max-width: 925px) 925px, (max-width: 1254px) 1254px, (max-width: 1506px) 1506px, (max-width: 1695px) 1695px, (max-width: 2040px) 2040px, (min-width: 2401px) 2880px"
					imgSrcset={`${mainScript.assetPath}images/png/chapter-2/c2s3-01-claremont-homes-campus-1893-v1-taller-cropped_420.png 420w,
						${mainScript.assetPath}images/png/chapter-2/c2s3-01-claremont-homes-campus-1893-v1-taller-cropped_925.png 925w,
						${mainScript.assetPath}images/png/chapter-2/c2s3-01-claremont-homes-campus-1893-v1-taller-cropped_1254.png 1254w,
						${mainScript.assetPath}images/png/chapter-2/c2s3-01-claremont-homes-campus-1893-v1-taller-cropped_1506.png 1506w,
						${mainScript.assetPath}images/png/chapter-2/c2s3-01-claremont-homes-campus-1893-v1-taller-cropped_1695.png 1695w,
						${mainScript.assetPath}images/png/chapter-2/c2s3-01-claremont-homes-campus-1893-v1-taller-cropped_2040.png 2040w,
						${mainScript.assetPath}images/png/chapter-2/c2s3-01-claremont-homes-campus-1893-v1-taller-cropped.png 2880w`}
					imgSrc={`${mainScript.assetPath}images/png/chapter-2/c2s3-01-claremont-homes-campus-1893-v1-taller-cropped.png`}
					imgAlt={content.chapters.second.image_with_arrows.img_alt}
					imgCaption={content.chapters.second.image_with_arrows.caption}
					elClass="chapter-2__image-arrows__img"
				/>
			</div>
		</div>
	);
};

export default ImageWithArrows;
